import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
  authRequired: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, authRequired }) => {
  const token = localStorage.getItem("token");

  if (authRequired && !token) {
    return <Navigate to="/auth" replace />;
  }

  if (!authRequired && token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
